<template>
  <div class="input-busca-wrapper">
    <img src="@/assets/lupa.png" alt="lupa" width="20" height="20" />
    <input type="text" placeholder="Pesquisar" class="input-busca" v-model="termoBusca" @input="onSearch" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";

const props = defineProps({
  filtro: {
    type: String,
    default: "GERAL",
  }
});

const emits = defineEmits(["pesquisar", "update:modelValue"]);

const route = useRoute();

const termoBusca = ref("");
let timeoutId = null;

watch(
  () => route.query.q,
  (newVal) => {
    const termo = newVal || "";
    if (termo !== termoBusca.value) {
      termoBusca.value = termo;
    }
  },
  { immediate: true }
);

function onSearch() {
  if (timeoutId) clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    emits("update:modelValue", termoBusca.value);
    emits("pesquisar", termoBusca.value);
  }, 400);
}
</script>

<style scoped>
.input-busca-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-busca-wrapper img {
  position: absolute;
  left: 10px;
  filter: invert(17%) sepia(74%) saturate(2506%) hue-rotate(247deg) brightness(68%) contrast(104%);
}

.input-busca {
  border-radius: 5px;
  padding: 6px 12px 6px 38px;
  font-size: 0.85rem;
  width: 342px;
}

.input-busca::placeholder {
  color: var(--preto);
  opacity: 1;
}

@media (max-width: 600px) {
  .input-busca {
    width: 100% !important;
  }

  .input-busca-wrapper {
    width: 100%;
  }


}
</style>
